<template>
    <TransitionRoot as="template" :show="show">
        <Dialog as="div" class="fixed inset-0 overflow-hidden" @close="close()">
            <div class="absolute inset-0 overflow-hidden">
                <DialogOverlay class="absolute inset-0 bg-gray-500 opacity-75"/>

                <div class="fixed inset-y-0 pl-16 max-w-full right-0 flex">
                    <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700"
                                     enter-from="translate-x-full" enter-to="translate-x-0"
                                     leave="transform transition ease-in-out duration-500 sm:duration-700"
                                     leave-from="translate-x-0" leave-to="translate-x-full">
                        <div class="w-screen max-w-2xl">
                            <form class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl"
                                  @submit.prevent="submit">
                                <div class="flex-1 h-0 overflow-y-auto">
                                    <div class="py-6 px-4  bg-amaze-coral sm:px-6">
                                        <div class="flex items-center justify-between">
                                            <DialogTitle class="text-lg text-white font-bold" v-if="form.id">
                                                Update Expense
                                            </DialogTitle>
                                            <DialogTitle class="text-lg text-white font-bold" v-else>
                                                Create Expense
                                            </DialogTitle>
                                            <div class="ml-3 h-7 flex items-center">
                                                <button type="button"
                                                        class="bg-amaze-coral rounded-md text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                        @click="close()">
                                                    <span class="sr-only">Close panel</span>
                                                    <XIcon class="h-6 w-6" aria-hidden="true"/>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="mt-1">
                                            <p class="text-sm text-white">
                                                Get started by filling in the information below to create a new
                                                expense.
                                            </p>
                                        </div>
                                    </div>
                                    <SlideOutErrors :show="showErrors === true"/>
                                    <div class="flex-1 flex flex-col justify-between">
                                        <div class="px-4 divide-y divide-gray-200 sm:px-6">
                                            <div class="mt-6 grid grid-cols-2 gap-4">
                                                <div class="col-span-2">
                                                    <h3 class="text-lg leading-6 font-medium text-gray-900">Expense
                                                        Information</h3>
                                                </div>
                                                <div>
                                                    <label for="employee_name"
                                                           class="block text-sm text-gray-900 required">
                                                        Employee Name
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="employee_name" v-model="form.user_id" disabled
                                                                :class="{'border-red-500': form.errors.user_id}"
                                                                class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected v-html="'Select an option'"></option>
                                                            <option v-for="(user,index) in users"
                                                                    v-html="user.name" :value="user.id"></option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="paid_at_date"
                                                           class="block text-sm text-gray-900 required">
                                                        Transaction Date
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="date" v-model="form.paid_at" id="paid_at_date"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.paid_at}"
                                                        />
                                                    </div>
                                                </div>

                                                <div>
                                                    <label for="project"
                                                           class="block text-sm text-gray-900 required">
                                                        Project
                                                    </label>
                                                    <div class="mt-1" v-if="firstParam == 'expenses'">
                                                        <v-select
                                                            class="mt-1"
                                                            :class="{'border-red-500': form.errors.project_id}"
                                                            :options="projects"
                                                            label="select_title"
                                                            :reduce="projects => projects.id"
                                                            v-model="form.project_id"
                                                        />
                                                    </div>
                                                    <div v-else>
                                                        <input
                                                            type="text"
                                                            id="project_reference"
                                                            disabled
                                                            :value="this.project.reference + ' / ' + this.project.title"
                                                            class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                        >
                                                    </div>
                                                </div>

                                                <div>
                                                    <label for="project"
                                                           class="block text-sm text-gray-900 required">
                                                        Quote
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="quote" v-model="form.quote_id"
                                                                :class="{'border-red-500': form.errors.quote_id}"
                                                                class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected v-html="'Select a quote'"></option>
                                                            <option v-for="(quote,index) in quotes"
                                                                    v-html="quote.name" :value="quote.id"></option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="col-span-2">
                                                    <h3 class="text-lg leading-6 font-medium text-gray-900">Deposit
                                                        Information</h3>
                                                </div>
                                                <div>
                                                    <label for="expense-amount"
                                                           class="block text-sm text-gray-900 required">
                                                        Expense Amount
                                                    </label>
                                                    <div class="mt-1">
                                                        <input type="text" id="expense-amount" v-model="form.amount"
                                                               class="block w-full shadow-sm sm:text-sm focus:ring-indigo-500 focus:border-light-pitch-purple border-gray-300 rounded-md"
                                                               :class="{'border-red-500': form.errors.amount}"
                                                        />
                                                    </div>
                                                </div>

                                                <div>
                                                    <label for="expense_type_id"
                                                           class="block text-sm text-gray-900 required">
                                                        Expense Type
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="expense_type_id" v-model="form.expense_type_id"
                                                                :class="{'border-red-500': form.errors.expense_type_id}"
                                                                class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected
                                                                    v-html="'Select an expense type'"></option>
                                                            <option v-for="(expense_type,index) in expense_types"
                                                                    v-html="expense_type.name"
                                                                    :value="expense_type.id"></option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="transaction_type_id"
                                                           class="block text-sm text-gray-900 required">
                                                        Transaction Type
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="transaction_type_id" v-model="form.transaction_type_id"
                                                                :class="{'border-red-500': form.errors.transaction_type_id}"
                                                                class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected
                                                                    v-html="'Select a transaction type'"></option>
                                                            <option
                                                                v-for="(transaction_type,index) in transaction_types"
                                                                v-html="transaction_type.name + ' (' + transaction_type.title + ')'"
                                                                :value="transaction_type.id"></option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div>
                                                    <label for="vat_rate"
                                                           class="block text-sm text-gray-900 required">
                                                        VAT Percentage
                                                    </label>
                                                    <div class="mt-1">
                                                        <select id="vat_rate" v-model="form.country_vat_rate_id"
                                                                :class="{'border-red-500': form.errors.country_vat_rate_id}"
                                                                class="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                                                            <option value selected
                                                                    v-html="'Select a VAT Rate'"></option>
                                                            <option v-for="(vat_rate,index) in vat_rates" :key="index"
                                                                    v-html="vat_rate.country_code + ' - ' + vat_rate.label + ' (' + vat_rate.percentage + '%)'"
                                                                    :value="vat_rate.id"></option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-span-2">
                                                    <label for="description"
                                                           class="block text-sm text-gray-900">
                                                        Description
                                                    </label>
                                                    <div class="mt-1">
                                                        <editor  ref="description"
                                                                          v-model="form.description"
                                                                          :class="{'border-red-500': form.errors.description}"
                                                                          class="min-h-[150px] mt-1 block w-full bg-white border border-gray-300 shadow-sm py-2 px-3"
                                                                          ></editor>
                                                    </div>
                                                </div>
                                                <div class="col-span-2">
                                                    <label
                                                           class="block text-sm text-gray-900">
                                                        Attachments
                                                    </label>
                                                    <div class="mt-1">
                                                        <dd class="my-2 text-sm text-gray-900" v-if="form.receipts.length > 0">
                                                            <ul role="list" class="border border-gray-200 rounded-md divide-y divide-gray-200">
                                                                <li class="pl-3 pr-4 py-3 flex items-center justify-between text-sm" v-for="(receipt,index) in this.form.receipts">
                                                                    <div class="w-0 flex-1 flex items-center">
                                                                        <PaperClipIcon class="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" />
                                                                        <span class="ml-2 flex-1 w-0 truncate"> {{ receipt }} </span>
                                                                    </div>
                                                                    <div class="ml-4 flex-shrink-0">
                                                                        <a :href="route('frontend.expenses.expense.download', [this.form.id, receipt])" class="font-medium text-pitch-purple hover:text-light-pitch-purple"> <DownloadIcon class="w-4 h-4" /> </a>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </dd>
                                                        <label class="w-full mb-4 flex flex-col items-center px-4 py-6 bg-white text-blue rounded-lg tracking-wide uppercase border border-blue cursor-pointer">
                                                            <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                                                <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                                                            </svg>
                                                            <span v-if="form.file_uploads.length  === 0" class="mt-2 text-base leading-normal">Select a file</span>
                                                            <span v-else>{{ form.file_uploads.length }} file<span v-if="form.file_uploads.length > 1">s</span> selected for upload</span>
                                                            <input type='file' class="hidden" multiple @change="prepareFileUpload($event)" />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="flex-shrink-0 px-4 py-4 flex justify-end">
                                    <button type="button"
                                            class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                            @click="close()">
                                        Close
                                    </button>
                                    <button :disabled="form.processing || !form.isDirty" type="submit"
                                            class=" ml-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm rounded-md text-white bg-amaze-coral hover:bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-200">
                                        <span v-if="updating === true">Update</span>
                                        <span v-else>Save</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script>
import {ref, reactive, onMounted} from 'vue'
import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {XIcon} from '@heroicons/vue/outline'
import {LinkIcon, PlusSmIcon, QuestionMarkCircleIcon, ExclamationCircleIcon, UploadIcon, PaperClipIcon, DownloadIcon} from '@heroicons/vue/solid'
import {useForm, usePage} from '@inertiajs/vue3'
import Inertia from '@inertiajs/vue3'
import SlideOutErrors from "@/Components/SlideOutErrors.vue";
import {mapState} from "vuex";
import {emitter} from "@/eventHub";
import Editor from "@/Components/Editor.vue";

export default {
    components: {
        SlideOutErrors,
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        LinkIcon,
        PlusSmIcon,
        QuestionMarkCircleIcon,
        ExclamationCircleIcon,
        XIcon,
        UploadIcon,
        PaperClipIcon,
        DownloadIcon,
        Editor
    },
    computed: {
        ...mapState({
            user: state => state.expenses.user ?? null,
            users: state => state.expenses.users ?? null,
            projects: state => state.expenses.projects ?? null,
            expense_types: state => state.expenses.expense_types ?? null,
            transaction_types: state => state.expenses.transaction_types ?? null,
            vat_rates: state => state.expenses.vat_rates ?? null,
            currencies: state => state.expenses.currencies ?? null,
            statuses: state => state.expenses.statuses ?? null,
            currency() {
                return this.currencies.find(currency => currency.id === this.form.currency_id)
            }
        }),
        expenseMapping: function() {
            this.form.office_id = usePage().props.project.office_id ?? usePage().props.auth.user.office_id;
            this.form.organisation_id = usePage().props.project.organisation_id;
            this.form.project_id = usePage().props.project.id
        },
    },
    setup(prop, context) {

        const firstParam = ref('');

        const show = ref(false)

        const showErrors = ref(false)

        const updating = false;

        const project = usePage().props.project;

        const project_dropdown_disabled = false;

        const form = useForm({
            id: null,
            user_id: "",
            paid_at: "",
            amount: null,
            gbp_amount: null,
            expense_type_id: "",
            transaction_type_id: "",
            country_vat_rate_id: "",
            description: "",
            receipts: [],
            project_id: "",
            quote_id: "",
            file_uploads: [],
            office_id: "",
        })

        function submit() {
            this.form.amount = this.form.amount.replace(',','.');
            if (this.updating) {
                this.form.post(route('frontend.expenses.expense.update', this.form.id), {
                    onSuccess: page => {
                        this.show = false;
                        this.showErrors = false;
                        this.form.reset();
                    },
                    onError: errors => {
                        this.showErrors = true;
                    }
                });
            } else {
                this.form.post(route('frontend.expenses.store'), {
                    onSuccess: page => {
                        this.show = false;
                        this.showErrors = false;
                        this.form.reset();
                    },
                    onError: errors => {
                        this.showErrors = true;
                    this.form.amount = this.formatCurrency(this.form.amount, this.currency.code)

                    }
                });
            }
        }

        function close() {
            this.form.reset();
            this.form.clearErrors();
            this.updating = false;
            let project_dropdown = document.getElementById('project_dropdown');
            this.project_dropdown_disabled = false
            this.show = false;
        }

        function open() {
            if (!this.form.user_id) {
                this.form.user_id = usePage().props.auth.user.id
            }

            this.$store.dispatch('expenses/getData', {
                project_id: typeof this.form.project_id !== "undefined" ? this.form.project_id : null,
                currentUserId: this.form.user_id,
            });
            this.form.office_id = usePage().props.auth.user.office_id
            this.form.clearErrors();
            this.show = true;
        }

        const emitter = emitter;

        onMounted(() => {
            const currentUrl = new URL(window.location.href);
            const pathParts = currentUrl.pathname.split('/').filter(Boolean); // Filters out empty strings
            firstParam.value = pathParts[0] || null;
        });

        return {
            firstParam,
            show,
            form,
            submit,
            updating,
            close,
            open,
            showErrors,
            emitter,
            project_dropdown_disabled
        }
    },
    mounted() {
        emitter.on('openExpenseSlideout', (project) => {
            if (typeof project !== 'undefined') {
                this.form.project_id = project.id
                this.project = project;
                // Disable the project dropdown.
                this.project_dropdown_disabled = true
            }
            this.getProjectQuotes();
            this.open();
        });

        emitter.on('editExpenseSlideout', (expense) => {
            this.updating = true;
            this.form.id = expense.id;
            this.form.description = expense.description;
            this.form.country_vat_rate_id = expense.country_vat_rate_id;
            this.form.expense_type_id = expense.expense_type_id;
            this.form.transaction_type_id = expense.transaction_type_id;
            this.form.amount = this.formatCurrency(expense.amount, expense.project.bank_account.currency.code)
            this.form.user_id = expense.user_id
            this.form.paid_at = expense.paid_at
            this.form.receipts = expense.receipts ?? []
            this.form.office_id = expense.office_id
            this.form.organisation_id = expense.organisation_id
            this.form.project_id = expense.project_id
            this.form.quote_id = expense.quote_id
            this.project = expense.project;
            this.getProjectQuotes();
            this.open();
        });
    },
    data() {
        return {
            quotes: false
        }
    },
    methods: {
        prepareFileUpload(event) {
            this.form.file_uploads = event.target.files
        },
        getProjectQuotes()
        {
            axios.get(route('frontend.project.get_quotes', {
                project: this.form.project_id
            })).then(result => {
                this.quotes = result.data.quotes;
            });
        },
    },
    watch: {
        'form.project_id': {
            deep: true,
            handler(id) {
                this.getProjectQuotes();
            }
        },
    }
}
</script>
